// Framework
import TakeTourComponent from './TakeTourComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getLocale } from 'actions/language/selectors';
import { startMultiPageTour } from 'actions/onboarding/onboardingActions';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  locale: getLocale(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      startMultiPageTour
    },
    dispatch
  );
};

// Create higher-order component which feeds in specified props.
const TakeTourContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TakeTourComponent);

export default TakeTourContainer;



// WEBPACK FOOTER //
// ./src/components/common/SideMenu/TakeTour/TakeTourContainer.js